import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
// Firebase Analytics is now initialized asynchronously after page load
// No need to import here as it's deferred for better performance

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);